import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { SharedViewComponent } from '../../models/shared-view-component';

@Injectable()
export class SharedItemsService {
  private _faqItems: ReplaySubject<SharedViewComponent> = new ReplaySubject();

  constructor() { }

  public getFaqItems(): Observable<SharedViewComponent> {
    return this._faqItems;
  }

  public addFaqItem(item: SharedViewComponent) {
    this._faqItems.next(item);
  }
}
